import { Init, RootUrl } from "@unify/web";
import { HtmxInit } from "@unify/web/dist/htmx";
import { Log, LogLevel } from "@unify/web/dist/logger";
import { ValidationService } from "aspnet-client-validation";
import Tooltip from "bootstrap/js/dist/tooltip";

(async () => {
  let theme = document.documentElement.getAttribute("data-unify-theme");

  if (theme) {
    await import(/* webpackChunkName: "[request]-theme" */ `./themes/${theme}`);
  }
})();

async function main() {
  try {
    Init();
    HtmxInit();
    require("htmx.org/dist/ext/class-tools");

    window.addEventListener("error", (evt) => {
      const e = (evt as unknown as CustomEvent).detail;

      if (e && e.type === "htmx:afterRequest") {
        Log(LogLevel.ERROR, e.detail.xhr.responseText);
      } else {
        Log(LogLevel.ERROR, evt.error.message);
      }
    });

    document.body.addEventListener("htmx:afterSettle", (evt) => {
      console.log("htmx settled", evt);
    });

    if (document.readyState === "loading") {
      // Loading hasn't finished yet
      document.addEventListener("DOMContentLoaded", DOMContentLoaded);
    } else {
      // `DOMContentLoaded` has already fired
      DOMContentLoaded();
    }
  } catch (error) {
    throw error;
  }
}

async function DOMContentLoaded() {
  window.unify.validator = new ValidationService(
    process.env.NODE_ENV === "production" ? undefined : global.console
  );
  window.unify.validator.bootstrap();

  //Enable tooltips
  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
  );
  const tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
  );

  //Fix sidebar active link
  const sidebarLinks = document.querySelectorAll(
    ".sidebar-menu .list-group-item"
  );
  sidebarLinks.forEach((link) => {
    let url = link.getAttribute("href");
    if (url) {
      // Remove trailing numeric parts of the URL paths for comparison
      const cleanUrl = url.replace(/\.+|(\/\d)+/g, '');
      const cleanPathname = window.location.pathname.replace(/\.+|(\/\d)+/g, '');
      
      if (cleanUrl === cleanPathname) {
        link.classList.add("active");
      } else {
        link.classList.remove("active");
      }
    }
  });
}

main()
  .then(() => Log(LogLevel.INFO, "Electives main:> finished on uri", RootUrl()))
  .catch((error) =>
    Log(LogLevel.ERROR, "Electives main:> failed to initialize", error)
  );
